import { OrgFullDetail } from "@garther/interfaces";
import { Box } from "@garther/ui/components";
import { useI18n } from "@garther/ui/libs";

interface OrgAboutProps {
  org: OrgFullDetail;
}

export function OrgAbout({ org }: OrgAboutProps) {
  const { t } = useI18n();
  return (
    <div className="space-y-6">
      <Box className="space-y-4">
        <p className="text-responsive-base font-medium text-text-secondary">
          {t("org.about.title", { orgName: org.name })}
        </p>
        <p
          className="text-responsive-base font-normal text-text-primary leading-relaxed"
          dangerouslySetInnerHTML={{ __html: org.description }}
        />
        <div className="bg-background-highlight rounded-sm p-4">
          <p className="text-responsive-sm font-medium text-text-secondary pb-2">{t("org.about.mission")}</p>
          <p
            className="text-responsive-base font-normal text-text-primary"
            dangerouslySetInnerHTML={{ __html: org.mission as string }}
          />
        </div>
      </Box>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-6">
        <Box>
          <p className="text-responsive-base text-text-secondary font-medium">
            {t("org.performance.totalEvents")}
          </p>
          <p className="text-responsive-md text-text-primary font-normal">{org.stats.totalEvents}</p>
        </Box>
        <Box>
          <p className="text-responsive-base text-text-secondary font-medium">
            {t("org.performance.avgAttendance")}
          </p>
          <p className="text-responsive-md text-text-primary font-normal">{org.stats.avgAttendance}</p>
        </Box>
      </div>
    </div>
  );
}
